export * from "./DeleteClientModal";
